import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {
  transform(contact: string, countryCode: string): string {
    if(!contact) return '';
    if(!countryCode) return contact;
    const code = countryCode.split('|')[0];
    return `${code}${contact}`;
  }
} 